"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FavoritesHeartIcon = void 0;
var UserAction = _interopRequireWildcard(require("@ori-events/user-action"));
var _icons = require("@ori-ui/icons");
var _auth = require("@ori/auth");
var _testidGenerator = _interopRequireDefault(require("@ori/testid-generator"));
var _react = require("react");
var _constants = require("../../constants");
var _hooks = require("../../hooks");
var _useFavoritesLinkAndText = require("../../hooks/useFavoritesLinkAndText");
var _constants2 = require("./constants");
var _styles = require("./styles");
var _jsxRuntime = require("react/jsx-runtime");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const FavoritesHeartIcon = () => {
  const {
    isAnonymousUser
  } = (0, _auth.useToken)();
  const [isOnFavorites, setIsOnFavorites] = (0, _react.useState)(false);
  const [ref, Icon] = (0, _hooks.useHover)(_icons.HeartFilled, _icons.Heart, isAnonymousUser);
  const {
    getTestId
  } = (0, _testidGenerator.default)();
  const {
    favoritesLink,
    favoritesText
  } = (0, _useFavoritesLinkAndText.useFavoritesLinkAndText)();
  (0, _react.useEffect)(() => {
    setIsOnFavorites(window.location.pathname.includes(favoritesLink));
  }, [favoritesLink]);
  const handleClick = (0, _react.useCallback)(() => {
    UserAction.dispatch(_constants.CLICK_FAVORITE_ICON);
  }, []);
  if (isAnonymousUser) {
    return null;
  }
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.FavoritesHeartRoot, {
    ref: ref,
    "aria-label": favoritesText,
    "data-testid": getTestId(_constants2.FAVORITE_HEART_ROOT),
    href: isOnFavorites ? undefined : favoritesLink,
    onClick: handleClick,
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)(Icon, {
      fontSize: "inherit"
    })
  });
};
exports.FavoritesHeartIcon = FavoritesHeartIcon;
